import { render, staticRenderFns } from "./ShopifyCheckout.vue?vue&type=template&id=029c1208&scoped=true"
import script from "./ShopifyCheckout.vue?vue&type=script&lang=js"
export * from "./ShopifyCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029c1208",
  null
  
)

export default component.exports